function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  padding: 0.75rem;\n  border: none;\n  background-color: var(--theme-paper-hover, #f9fafb);\n  color: var(--theme-text, #111827);\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: background-color 0.2s;\n  border-top: 1px solid var(--theme-border, #e5e7eb);\n\n  &:hover {\n    background-color: var(--theme-hover, #f3f4f6);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  .dark & {\n    background-color: var(--theme-paper-hover-dark, #374151);\n    color: var(--theme-text-dark, #f9fafb);\n    border-top-color: var(--theme-border-dark, #4b5563);\n\n    &:hover {\n      background-color: var(--theme-hover-dark, #4b5563);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var StyledLoadMoreButton = styled.button(_templateObject());
var LoadMoreButton = function(param) {
    var onClick = param.onClick, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, children = param.children, className = param.className, loadingText = param.loadingText;
    return /*#__PURE__*/ React.createElement(StyledLoadMoreButton, {
        onClick: onClick,
        disabled: disabled || isLoading,
        className: className
    }, isLoading ? loadingText : children);
};
export default LoadMoreButton;
